import * as _ from 'lodash';
import { User } from './user.model';
import { UserInterface } from './user.interface';

export class UserFactory {

    static empty(): User {
        return new User(false, false, false, false, '', null, '', '', {}, [], {}, '', '', '', '', '', '', [], [], '', '', false, false, '', {}, [], 0, '', '', false, false);
    }

    static fromObject(raw: UserInterface | any): User {
        if (raw.success === false) {
            throw new Error(raw.message);
        }
        return new User(
            raw.isAdmin,
            raw.isAdminGlobal,
            raw.isDemo,
            raw.isActivatedByDefault,
            raw.id,
            raw.date && raw.date._seconds ? new Date(raw.date._seconds * 1000) : raw.date,
            raw.firstname,
            raw.lastname,
            raw.role,
            raw.rights,
            raw.editableCategories,
            raw.email,
            raw.password,
            raw.address,
            raw.city,
            raw.zipCode,
            raw.mobile,
            raw.groups,
            raw.children,
            raw.secret,
            raw.appName,
            raw.receiveMessageAsMail,
            raw.outOfOffice,
            raw.outOfOfficeText,
            raw.tokens,
            raw.fields,
            raw.messagesSentLast3Months,
            raw.description,
            raw.temporaryUserId,
            raw.isDeleted,
            raw.disabled,
        );
    }
}



// WEBPACK FOOTER //
// ./src/app/users/shared/user.factory.ts